// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__86qKc","col":"styles_col__1AHSx"};